// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import store from './store'
import Axios from 'axios'
//import wx from 'weixin-jsapi'

import BaiduMap from 'vue-baidu-map'
Vue.use(BaiduMap, {
    // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
    ak: 'XYGaAE5iabNQYtwv9nivEdn9BpyfHWHw'
});

Vue.use(Vuex)
    /* 挂载全局对象 start */
Vue.prototype.$axios = Axios;

Vue.config.productionTip = false

import { VueJsonp } from 'vue-jsonp'
Vue.use(VueJsonp);


// 移动端适配
import 'amfe-flexible'

//vant组件引入
// import Button from 'vant'
import 'vant/lib/index.css'
import '../static/css/common.css'
import { Toast, NavBar, Sticky, Notify, Loading } from "vant";
Vue.use(NavBar);
Vue.use(Sticky);
Vue.use(Loading);

//api请求挂载
import api from './api/index'
Vue.prototype.$api = api
Vue.prototype.$Toast = Toast
Vue.prototype.$Notify = Notify


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>',

})


// WEBPACK FOOTER //
// ./src/main.js